<div class="input-overview-wrapper">
  @if (values?.controls.personalInfos) {
    <p>{{ 'gbr.overview.step-personal' | translate }}</p>
    <div class="info-grid">
      @if (values?.controls.personalInfos.value.isSingleParent !== null) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.single-parent' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.isSingleParent"
          [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
      }
      @if (values?.controls.personalInfos.value.isShiftWorker !== null) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.change-shift' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.isShiftWorker"
          [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
      }
      @if (values?.controls.personalInfos.value.email) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.email' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.email"></coin-simple-gbr-input>
      }
      @if (values?.controls.personalInfos.value.hasParentLeave !== null) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.parent-leave' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.hasParentLeave"
          [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
      }
      @if (values?.controls.personalInfos.value.hasDisabilities !== null) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.disability' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.hasDisabilities"
          [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
      }
      @if (values?.controls.personalInfos.value.hasCare !== null) {
        <coin-simple-gbr-input
          [label]="'gbr.personal-infos.care' | translate"
          [display]="true"
          [ngModel]="values?.controls.personalInfos.value.hasCare"
          [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
      }
    </div>
  }

  @if (values?.controls?.vacation && stepIndex > 1) {
    <p>{{ 'gbr.overview.step-vacation' | translate }}</p>
    <div class="info-grid">
      @if (values?.controls.vacation.value.country) {
        <coin-simple-gbr-input
          [label]="'gbr.vacation.country' | translate"
          [display]="true"
          [ngModel]="values?.controls.vacation.value.country"></coin-simple-gbr-input>
      }
      @if (values?.controls.vacation?.value?.period?.start) {
        <coin-simple-gbr-input
          class="vacation-period"
          [label]="'gbr.vacation.period' | translate"
          [display]="true"
          [ngModel]="values?.controls.vacation.value.period"
          [type]="simpleInputTypes.DateRange"></coin-simple-gbr-input>
      }
    </div>
  }

  @if (values?.controls?.spouse?.value && stepIndex > 2) {
    <p>{{ 'gbr.overview.partner-title' | translate }}</p>
    <div class="person">
      <coin-v2-card
        styleVariant="large"
        padding="none">
        @if (values?.controls.spouse.value) {
          <coin-siemens-energy-person-view
            [value]="values?.controls.spouse.value"
            [display]="true"></coin-siemens-energy-person-view>
        }
      </coin-v2-card>
    </div>
  }

  @if (values?.controls.children?.value?.length && stepIndex > 3) {
    <p>{{ 'gbr.overview.minor-children' | translate }}</p>
    @for (traveler of minorChildren; track traveler) {
      <div class="person">
        <coin-v2-card
          styleVariant="large"
          padding="none">
          <coin-siemens-energy-person-view
            [value]="traveler"
            [display]="true"
            [type]="personTypes.Child"></coin-siemens-energy-person-view>
        </coin-v2-card>
      </div>
    }
    <p>{{ 'gbr.overview.children' | translate }}</p>
    @for (traveler of adultChildren; track traveler) {
      <div class="person">
        <coin-v2-card
          styleVariant="large"
          padding="none">
          <coin-siemens-energy-person-view
            [value]="traveler"
            [display]="true"
            [type]="personTypes.Child"></coin-siemens-energy-person-view>
        </coin-v2-card>
      </div>
    }
  }
</div>
